import React from "react";
import { Chip } from "../Chip/Chip";
import styles from "./Chips.module.css";
import { HapticFeedback } from "../../utils/hapticFeedback";

export interface ChipData {
  id: string;
  icon: React.ReactNode;
  text: string;
}

interface ChipsProps {
  chips: ChipData[];
  selectedChip: string;
  onChipClick?: (chipId: string) => void;
}

export const Chips: React.FC<ChipsProps> = ({
  chips,
  selectedChip,
  onChipClick,
}) => {
  const handleChipClick = (chipId: string) => {
    if (chipId !== selectedChip) {
      HapticFeedback.selectionChanged(); // Только при смене выбора
      onChipClick?.(chipId);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.scrollContainer}>
        {chips.map((chip) => (
          <Chip
            key={chip.id}
            id={chip.id}
            icon={chip.icon}
            text={chip.text}
            selected={selectedChip === chip.id}
            onClick={() => handleChipClick(chip.id)}
          />
        ))}
      </div>
    </div>
  );
};
